<nb-card class="dialog update-data-settings" [nbSpinner]="loading">
  <nb-card-header class="header">
    <morva-icons
      class="close-cross"
      icon="close"
      (click)="closeDialog()"
    ></morva-icons>
    <p data-testid="data-update-header-text" class="header-text">تنظیمات به‌روزرسانی</p>
  </nb-card-header>

  <nb-card-body class="body" *ngIf="dataUpdateType">
    <form [formGroup]="dataBaseForm" class="form-container row g-3" style="margin-bottom: 15px;">
      <div class="rowContainer col-12 flex-column">
        <div class="col-12">
          <label class="section-title">حالت به‌روزرسانی</label>
        </div>
        <div class="col-12">
          <nb-radio-group class="d-flex flex-column" name="connection"
                          formControlName="dataUpdateType" (valueChange)="changeConnectionType($event)">
            <nb-radio data-testid="full-update-radio" [checked]="updateTypeEnum.FULL === dataUpdateType" [value]="updateTypeEnum.FULL">کامل (به‌روزرسانی
              کل منبع
              داده)
            </nb-radio>
            <nb-radio data-testid="incremental-update-radio" [checked]="updateTypeEnum.INCREMENTAL=== dataUpdateType" [value]="updateTypeEnum.INCREMENTAL">
              تدریجی
              (به‌روزرسانی بخشی از
              منبع داده)
            </nb-radio>
          </nb-radio-group>
        </div>
      </div>
      <ng-container *ngIf="dataUpdateType === 'FULL'">
        <div>
          <p class="sub-section-title">تنظیمات به‌روزرسانی کامل</p>

          <div class="col-12 align-self-start">
            <label class="label">تنظیمات بیشتر</label>
          </div>

          <div class="col-12">
            <nb-checkbox
              status="basic"
              class="checkbox form-control"
              formControlName="hasRowLimited"
              (checkedChange)="toggleRowLimited($event)">
              در صورتی که جدول مبدا از تعداد ردیف مشخصی کمتر
              بود، {{configuration.formType === 'CreateSqlServer' ? 'بارگذاری' : 'به‌روزرسانی'}} نشود.
            </nb-checkbox>
          </div>
          <div class="pe-4 d-flex col-12" *ngIf="dataBaseForm.controls['hasRowLimited'].value">
            <label for="rowLimit" class="label col-3">تعداد ردیف:</label>
            <input
              nbInput
              type="number"
              class="w-25 input form-control"
              id="rowLimit"
              formControlName="numberOfRowLimited">
          </div>

          <!--          <div class="col-12">-->
          <!--            <nb-checkbox-->
          <!--              status="basic"-->
          <!--              class="checkbox form-control"-->
          <!--              formControlName="hasTopN"-->
          <!--              (checkedChange)="toggleTopN($event)">-->
          <!--              تعداد ردیف مشخصی از کل ردیف‌های جدول-->
          <!--              مبدا {{configuration.formType === 'CreateSqlServer' ? 'بارگذاری' : 'به‌روزرسانی'}} شود.-->
          <!--            </nb-checkbox>-->
          <!--          </div>-->
          <!--          <div class="pe-4 d-flex col-12">-->
          <!--            <label for="TopN" class="label col-3">تعداد ردیف بارگذاری:</label>-->
          <!--            <input-->
          <!--              nbInput-->
          <!--              disabled="true"-->
          <!--              type="number"-->
          <!--              class="w-25 input form-control"-->
          <!--              id="TopN"-->
          <!--              formControlName="numberOfTopN">-->
          <!--          </div>-->
        </div>
      </ng-container>
      <ng-container *ngIf="dataUpdateType === 'INCREMENTAL'">
        <p style="font-size: 14px;font-weight: 400;color: #666666;margin-bottom: 8px;">تنظیمات حالت تدریجی</p>
        <p class="label" style="margin-bottom: 8px;">در حالت تدریجی، صرفا داده‌هایی که زمان تغییر آن‌ها در بازه زمانی
          مشخص‌شده باشند به‌روز می‌شوند.
          (تغییر داده
          می‌تواند ایجاد، ویرایش یا حذف آن باشد. در صورتی که وضعیت حذف True باشد داده حذف می‌شود.)</p>

        <div class="rowContainer col-12">
          <div class="col-3">
            <label class="form-label d-flex">ستون کلید*
              <morva-icons class="icon-16" icon="activeInfoCircle"
                           [nbTooltip]="'ستون باید کلید اصلی (primary key) باشد.'"></morva-icons>
            </label>
          </div>
          <div class="col-3 drop-down-design-setting">
            <ng-select class="design-setting-ng-select" bindLabel="name" bindValue="id"
                       formControlName="id" (change)="changeSelectedConnection($event)">
              <ng-container *ngFor="let item of dataSource.columns">
                <ng-option *ngIf="item.dataType === 'WholeNumber'" [value]="item">{{item.name}}</ng-option>
              </ng-container>
            </ng-select>
          </div>
        </div>
        <div class="rowContainer col-12">
          <div class="col-3">
            <label class="form-label d-flex">ستون زمان تغییر*
              <morva-icons class="icon-16" icon="activeInfoCircle"
                           [nbTooltip]="'نوع داده ستون باید DATE-TIME باشد.\nزمان با حساسیت دقیقه محاسبه می‌شود. (مثال: ۱۰:۳۱ - ۱۴۰۲/۰۱/۰۱)\nزمان تغییر همان زمان ایجاد ویرایش و حذف ستون می‌باشد.'"></morva-icons>
            </label>
          </div>
          <div class="col-3 drop-down-design-setting">
            <ng-select class="design-setting-ng-select" bindLabel="name" bindValue="id"
                       formControlName="updated" (change)="changeSelectedConnection($event)">
              <ng-container *ngFor="let item of dataSource.columns">
                <ng-option *ngIf="item.dataType === 'Date'" [value]="item">{{item.name}}</ng-option>
              </ng-container>
            </ng-select>
          </div>
        </div>
        <div class="rowContainer col-12">
          <div class="col-3">
            <label class="form-label d-flex">ستون وضعیت حذف
              <morva-icons class="icon-16" icon="activeInfoCircle"
                           [nbTooltip]="'نوع داده ستون باید BOOLEAN باشد.\nمقدار ستون برای ردیف حذف‌شده باید True باشد.'"></morva-icons>
            </label>
          </div>
          <div class="col-3 drop-down-design-setting">
            <ng-select class="design-setting-ng-select" bindLabel="name" bindValue="id"
                       formControlName="deleted" (change)="changeSelectedConnection($event)">
              <ng-container *ngFor="let item of dataSource.columns">
                <ng-option *ngIf="item.dataType === 'Boolean'" [value]="item">{{item.name}}</ng-option>
              </ng-container>
            </ng-select>
          </div>
        </div>
        <p style="
    font-size: 12px;
    font-weight: 400;
    color: #4D4D4D;
    display: flex;
    margin-bottom: 10px;
">تعیین بازه زمانی برای ستون زمان تغییر
          <morva-icons class="icon-16" icon="activeInfoCircle"
                       nbTooltip="برای از دست ندادن داده‌ها، مقدار ستون زمان تغییر، بهتر است  از بازه زمانبندی به‌روزرسانی بیشتر باشد.
                        زمانبندی به‌روزرسانی: هر {{((dataBaseForm.controls['count'].value || 1)|persianNumber) + ' ' + timeMap[dataBaseForm.controls['timeMode'].value]}}    یک بار  "></morva-icons>
        </p>
        <div class="d-flex label time-mode-container">
          <span>داده‌هایی که در بازه زمانی</span>

          <input
            nbInput
            style="width: 50px;"
            type="number"
            min="1"
            class="input form-control"
            id="name"
            (blur)="dataBaseForm.controls['count'].value===null?dataBaseForm.controls['count'].setValue(1):0"
            formControlName="count">
          <div class="drop-down-design-setting">
            <ng-select class="design-setting-ng-select" bindLabel="name" bindValue="id"
                       [items]="timeModeList"
                       formControlName="timeMode" (change)="changeSelectedConnection($event)"></ng-select>
          </div>
          <span>پیش از زمان به‌روزرسانی هستند، به‌روز می‌شوند.</span>
        </div>
        <p style="
    margin-top: 8px;
    margin-bottom: 15px;
" class="label">به طور مثال اگر امروز به‌روزرسانی رخ دهد، از ۱۴۰۲/۰۹/۰۱ ساعت ۱۶:۰۰ تا ۱۴۰۲/۱۰/۰۱ ساعت ۱۶:۰۰ به‌روزرسانی می‌شود. </p>

      </ng-container>

      <div class="update-overview" [ngStyle]="{'padding-bottom':dataUpdateType === updateTypeEnum.FULL?'15px':'50px'}">
        <p class="title">نمای کلی به‌روزرسانی</p>
        <ng-container *ngIf="dataUpdateType === updateTypeEnum.FULL">
          <p class="label">کل ردیف‌های منبع داده به‌روزرسانی می‌شوند.</p>
          <div class="update-presentation">کل ردیف‌ها</div>
        </ng-container>
        <ng-container *ngIf="dataUpdateType === updateTypeEnum.INCREMENTAL">
          <p class="label" style="margin-bottom: 4px;">فقط
            داده‌های {{((dataBaseForm.controls['count'].value || 1)|persianNumber) + ' ' + timeMap[dataBaseForm.controls['timeMode'].value]}}
            پیش به‌روز
            می‌شود. (داده‌هایی که ایجاد، ویرایش
            یا حذف شده‌اند)</p>
          <div class="d-flex justify-content-start incremental-container">
            <div class="update-presentation active">
              <div class="indicator update">
                <span></span>
                <p>روز به‌روزرسانی</p>
              </div>
            </div>
            <div class="update-presentation main">بخش تدریجی</div>
            <div class="update-presentation active">
              <div class="indicator undefined">
                <span></span>
                <p
                  style="width: 60px;">{{((dataBaseForm.controls['count'].value || 1)|persianNumber) + ' ' + timeMap[dataBaseForm.controls['timeMode'].value]}}</p>
              </div>
            </div>
            <div class="update-presentation">بخش ثابت</div>
          </div>
        </ng-container>
      </div>

    </form>

    <mat-accordion class="help-container">
      <mat-expansion-panel #panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <morva-icons style="margin-left: 5px;" class="icon-16" icon="infoCircle"></morva-icons>
            راهنما
          </mat-panel-title>
          <!--          <span class="panel-toggle-text">{{panel.expanded ? 'کمتر' : 'بیشتر'}}</span>-->
        </mat-expansion-panel-header>
        <div class="help-content" *ngIf="dataUpdateType === updateTypeEnum.FULL">
          <p>حالت کامل به منظور به‌روزرسانی کل منبع داده می‌باشد.</p>
          <p>توجه! همه داشبوردهای منبع‌ داده فعلی طبق به‌روزرسانی جدید به‌روز می‌شوند.</p>
        </div>
        <div class="help-content incremental" *ngIf="dataUpdateType === updateTypeEnum.INCREMENTAL">
          <p>حالت تدریجی به منظور به‌روزرسانی بخشی از داده‌ است که در بازه زمانی مشخص‌شده ایجاد شده باشد. جدول مبداء
            برای به‌روزرسانی تدریجی، باید شامل شروط زیر باشد:</p>
          <p>۱. ستون زمان ایجاد داشته باشد. </p>
          <p>۲. این ستون از نوع تاریخ باشد.</p>
          <p style="margin-top: 15px;">توجه! هر گونه عملیات ویرایش یا حذفی که روی داده‌های ایجادشده در خارج از این بازه
            زمانی انجام شود
            به‌روزرسانی نمی‌شود.</p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--    <tart-connection-form [configuration]="configuration"-->
    <!--                          [connections]="connections"-->
    <!--                          [connection]="connection"-->
    <!--                          [connectionTables]="connectionTables"-->
    <!--                          (validatorChange)="checkValidator($event)"-->
    <!--                          (selectedConnection)="loadConnectionTables($event)"></tart-connection-form>-->
  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-end footer">
    <button data-testid="cancel-button" nbButton class="cancel-button" (click)="closeDialog()">انصراف</button>
    <button data-testid="confirm-button" nbButton class="confirm-button" [disabled]="dataBaseForm.invalid || (dataUpdateType === updateTypeEnum.FULL && dataBaseForm.controls.hasRowLimited.value&& dataBaseForm.controls.numberOfRowLimited.value<1)"
            [nbSpinner]="submitState === 'submitting'"
            (click)="submit()">ذخیره
    </button>
  </nb-card-footer>
</nb-card>
